import API from "@/services/api";
import router from "@/router";

export default {
	fetchSchoolCount() {
		return API().get("primary-schools");
	},
	fetchSchoolsExport() {
		return API().get("primary-schools");
	},
	fetchSchools(currentPage, perPage) {
		return API().get("table/primary-schools", {
			params: {
				currentPage,
				perPage,
			},
		});
	},
	addSchool(params) {
		return API().post("primary-schools", params);
	},
	updateSchool(params) {
		return API().put(
			`primary-schools/${router.currentRoute.params.id}`,
			params
		);
	},
	getSchool(params) {
		return API().get(`primary-schools/${params.id}`);
	},
	fetchSchoolStudents(year) {
		return API().get(
			`primary-schools/${router.currentRoute.params.id}/students/${year}`
		);
	},
	addSchoolStudent(params) {
		return API().post(
			`primary-schools/${router.currentRoute.params.id}/add-student`,
			params
		);
	},
	deleteSchoolStudent(params) {
		return API().post(
			`primary-schools/${router.currentRoute.params.id}/delete-student`,
			params
		);
	},
	fetchSchoolTrainers() {
		return API().get(
			`primary-schools/${router.currentRoute.params.id}/trainers`
		);
	},
	addStudentMEForm(params) {
		//console.log("here");
		return API().post(`students/add-me-form`, params);
	},
	getPrimarySchoolLeanerData(id) {
		return API().get(`/primary-schools/primary-school-learner-data/${id}`);
	},
};
